import { BaseFetch } from "../main-model"
export default class ReportProcurementPlanModel extends BaseFetch {
    getReportStudentlBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentlBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportStudentAmountBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentAmountBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportStudentTalenBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentTalenBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportStudentDefectivenessBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentDefectivenessBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportStudentScholarshipBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentScholarshipBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportStudentAwardBy = (data) =>
    this.authFetch({
      url: "report-student/getReportStudentAwardBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
